// ProfileCard.js
import { Icon } from "@iconify/react/dist/iconify.js";
import WebSite from "./WebSite";
import MDCVisual from "./MDCVisual";
import Behance from "./Behance";
import Linkedin from "./Linkedin";
import Share from "./Share";
import VCard from "./vCard";
import "./ProfileCard.css";

const ProfileCard = () => (
  <div className="container">
    <div className="card-container">
      {/* PARTE 1: Imagen y descripción */}
      <div className="card-header">
        <div className="image">
          <img
            src="/images/profile-image.webp"
            alt="Imagen Mariela Ponce MDCVisual"
          />
        </div>
        <div className="descripcion">
          <h1>Mariela Ponce</h1>
          <MDCVisual />
          <address className="telefono-contenedor">
            {/* Contenedor de íconos */}
            <div className="iconos-telefono">
              {/* Teléfono con tooltip */}
              <span className="hover-text">
                <a
                  href="tel:+541158070675"
                  className="icon-button phone-button"
                  aria-label="Llamar por teléfono"
                >
                  <Icon icon="bi:telephone" />
                </a>
                <span className="tooltip-text fade" role="tooltip">
                  Llamar
                </span>
              </span>

              {/* WhatsApp con tooltip */}
              <span className="hover-text">
                <a
                  href="https://wa.me/541158070675"
                  className="icon-button whatsapp-button"
                  aria-label="Enviar mensaje por WhatsApp"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Icon icon="bi:whatsapp" />
                </a>
                <span className="tooltip-text fade" role="tooltip">
                  WhatsApp
                </span>
              </span>
            </div>
            {/* Número de teléfono */}
            <span>+54 11 5807 0675</span>
          </address>
          <adress className="email-contenedor">
            <span className="hover-text">
              <a
                href="mailto:m.ponce@mdcvisual.com.ar"
                className="phone-link"
                style={{ textDecoration: "none", color: "var(--icon-color)" }}
                aria-label="Enviar correo a m.ponce@mdcvisual.com.ar"
              >
                <Icon icon="bi:envelope" style={{ marginRight: "8px" }} />
                m.ponce@mdcvisual.com.ar
              </a>
              <span className="tooltip-text fade">Enviar correo</span>
            </span>
          </adress>
        </div>
      </div>
      {/* PARTE 2: Imagen QR (que crece) */}
      <div className="qr-flex-grow">
        <div className="image-qr">
          <img src="/images/qr-mariela.webp" alt="Imagen QR Mariela" />
        </div>
      </div>
      {/* PARTE 3: Botones e iconos (footer incluido) */}
      <div className="card-footer">
        <div className="buttons">
          <WebSite />
          <Behance />
          <Linkedin />
          <VCard />
          <Share />
        </div>
        <footer className="footer">
          <p
            style={{
              fontSize: "0.75rem",
              color: "#999",
              textAlign: "center",
              marginTop: "0rem",
            }}
          >
            Powered by <strong>Digital Card</strong> ·{" "}
            <a
              href="https://digitalcard.store"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#999" }}
            >
              digitalcard.store
            </a>
          </p>
        </footer>
      </div>
    </div>
  </div>
);

export default ProfileCard;
